<template>
  <div id="error-component">
    <b-row class="error-row">
      <b-col md="12">
        <b-row class="justify-content-center">
          <b-col md="12">
            <slot name="title"></slot>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col md="12">
            <slot name="subtitle"></slot>
          </b-col>
        </b-row>
          <b-row class="justify-content-center">
          <b-col md="12">
            <b-button
              id="goHome"
              variant="primary"
              href="/">
                Go Home
            </b-button>
          </b-col>
          </b-row>
          <br>
          <b-row class="justify-content-center">
            <b-col md="12">
              <slot name="message"></slot>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-button
                id="goForm"
                variant="primary"
                href="/request-listing">
                  Add a New Partnership
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
  </div>
</template>

<script>
export default {
  name: 'ErrorComponent'
}
</script>

<style lang="scss" scoped>
  .error-row {
    text-align: center;
    padding-top: 2%;
  }

  a {
    font-size: 1rem !important;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 1.75rem;
  }

  p {
    font-size: 1.25rem;
  }

  #goHome {
    background-color: rgb(215, 25, 32);
    border-color: rgb(215, 25, 32);
    margin-top: 0.25%;
    margin-bottom: 0.5%;
  }

  #goForm {
    background-color: rgb(215, 25, 32);
    border-color: rgb(215, 25, 32);
  }
</style>



// WEBPACK FOOTER //
// src/components/ErrorComponent.vue